import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {UrlQueryService} from '../../../../common/url-query/url-query.service';

@Injectable({
  providedIn: 'root'
})
export class ShortCallsProfilesApiService {

  constructor(private http: HttpClient) {}

  private readonly shortCallsUrl: string = 'calls/short';




  public getShortCallsProfiles(params: object = {}): Observable<any> {
    const generatedCallsQuotasUrl = UrlQueryService.addQueryParameters(this.shortCallsUrl, params);

    return this.http.get(generatedCallsQuotasUrl);
  }

  public getShortCallProfile(shortCallsProfileId): Observable<any> {
    return this.http.get(`${this.shortCallsUrl}/${shortCallsProfileId}`);
  }


  public addShortCallsProfile(shortCallProfile): Observable<any> {
    return this.http.post(this.shortCallsUrl, shortCallProfile);
  }

  public editShortCallsProfile(shortCallProfile, shortCallsProfileId): Observable<any> {
    return this.http.put(`${this.shortCallsUrl}/${shortCallsProfileId}`, shortCallProfile);
  }

  public deleteShortCallsProfile(shortCallsProfileId) {
    return this.http.delete(`${this.shortCallsUrl}/${shortCallsProfileId}`);
  }
}
